import { get } from './apiUtils';

const defaultUrl = '/WorkflowStatus/';

export default {
  getWorkflowStatusList: () => get(defaultUrl),
};
